<template>
  <div
    v-if="selectcertificate"
    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
  >
    <v-select
      v-if="!dataLoad"
      v-model="showNameCertificate"
      class="w-100"
      :options="certificateOptions"
      placeholder="Select By Certificate"
      label="text"
      :searchable="true"
      :clearable="true"
      @input="searchCertificateTable"
      @clear="clearCertificateSelection"
    />
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    selectcertificate: {
      type: Boolean,
      default: () => false,
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    certificateOptions: {
      type: Array,
      default: () => [],
    },
    // getAllData: {
    //   type: Function,
    //   default: () => () => {},
    // },
  },
  data() {
    return {
      showNameCertificate: null,
    }
  },
  watch: {
    showNameCertificate(newValue) {
      if (newValue === null) {
        this.clearCertificateSelection()
      }
    },
    certificateOptions: {
      handler(newOptions) {
        const matched = newOptions.find(
          /* eslint-disable-next-line */
          item => item['data-certificate'] === this.$route.query.certificate
            || item.value === this.$route.query.certificate,
        )
        if (matched) this.showNameCertificate = matched
      },
      immediate: true,
    },
  },
  methods: {
    async searchCertificateTable(selectedOption) {
      if (!selectedOption) {
        this.$emit('getIdCertificate', null)
        this.showNameCertificate = null
      } else {
        this.$emit('getIdCertificate', selectedOption['data-certificate'])
        this.showNameCertificate = selectedOption.text

        try {
          const response = await axios.get(
            `certificate/${selectedOption.value}`,
          )
          const data = decryptData(response.data.payload)?.data?.certificates
          this.getSubCertificate = data.map(item => ({
            value: item.id,
            text: `${item.name?.ar} - ${item.name?.en}`,
            'data-certificate': item.name?.en,
          }))
          this.$emit('getSubCertificateIdOptions', this.getSubCertificate)
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error}`,
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      }
      // await this.getAllData()
    },
    async clearCertificateSelection() {
      this.$emit('getIdCertificate', null)
      this.showNameCertificate = null
      try {
        const response = await axios.get('certificate/get-sub')
        const data = decryptData(response.data.payload)?.data?.groups

        this.getSubCertificate = data.map(item => ({
          value: item.id,
          text: `${item.name?.ar} - ${item.name?.en}`,
          'data-certificate': item.name?.en,
        }))
        this.$emit('getSubCertificateIdOptions', this.getSubCertificate)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      }
      // await this.getAllData()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
